import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'

import settings from "./modules/settings";
import auth from "./modules/auth";
import searchMachines from "./modules/search/machines";
import searchAccessories from "./modules/search/accessories";
import searchInnovations from "./modules/search/innovations";
import sheet from "./modules/sheet";
import compare from "./modules/compare";
import qualifyIndustry from "./modules/qualify/industry";
import qualifyConstruction from "./modules/qualify/construction";
import vuetour from "./modules/vuetour";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState()],
    modules: {
        settings,
        auth,
        searchMachines,
        searchAccessories,
        searchInnovations,
        sheet,
        compare,
        qualifyIndustry,
        qualifyConstruction,
        vuetour
    },
    actions: {
        clearAll({ commit }){
            commit("settings/reset")
            commit("auth/reset")
            commit("searchMachine/reset")
            commit("searchAccessories/reset")
            commit("searchInnovations/reset")
            commit("sheet/reset")
            commit("compare/reset")
            commit("qualifyIndustry/reset")
            commit("qualifyConstruction/reset")
            commit("vuetour/reset")
        }
    }
});
